import HomeContent from './HomeContent'
export default HomeContent
